import React from "react";

const Link = (props) => <span {...props} />;

export default Link;
